"use strict"

import React, {useEffect, useState} from "react"
import {observer} from "mobx-react"
import MobxReactForm from "mobx-react-form"
import moment from "moment"
import fields from "./filterFields"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"
import {injectIntl} from "react-intl"
import {Container, Box, Grid, Typography} from "@material-ui/core"
import XsButton from "../../global/ui/xsButton/xsButton"
import XsSearchSelect from "../../global/ui/xsSearchSelect/xsSearchSelect"
import XsTable from "../../global/ui/xsTable/xsTable"
import RequestStore from "./requestStore"
import RouterStore from "../../global/store/RouterStore"
import GlobalStore from "../../global/store/GlobalStore"
import SettingsStore from "../settings/settingsStore"
import XsInput from "../../global/ui/xsInput/xsInput"
import XsIconButton from "../../global/ui/xsButton/xsIconButton"

const columns = [
	{
		Header: "Poradie",
		width: 70,
		accessor: "request_sequence"
	},
	{
		Header: "Dátum odoslania žiadosti",
		width: 100,
		accessor: "sent_date_time",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Číslo žiadosti",
		width: 100,
		accessor: "request_number"
	},
	{
		Header: "Región",
		width: 100,
		accessor: "region_type_code_ext"
	},
	{
		Header: "Obchodné meno",
		width: 120,
		accessor: "company_name"
	},
	{
		Header: "IČO",
		width: 100,
		accessor: "company_identifier"
	},
	{
		Header: "Zariadenie",
		width: 160,
		accessor: "device_name"
	},
	{
		Header: "Stav žiadosti",
		width: 100,
		accessor: "status_name_ext"
	},
	{
		Header: "Predpokladaná hodnota",
		align: "right",
		width: 100,
		accessor: "expected_voucher_amount",
		Cell: (props) => (
			<div>{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"}).format(props.value)}</div>
		)
	},
	{
		Header: "Výška príspevku",
		align: "right",
		width: 100,
		accessor: "paid_voucher",
		Cell: (props) => (
			<div>{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"}).format(props.value)}</div>
		)
	}
]

function Requests() {
	const hooks = {
		onSubmit() {},
		onSuccess(form) {
			logger("SAVE", form.values())
			RequestStore.getRequests(form)
		},
		onError(form) {
			logger("CHYBY:", form.errors())
			GlobalStore.setNotificationMessage("Skontrolujte povinné polia", null, "error")
		}
	}

	const [form] = useState(new MobxReactForm(fields.load(), {plugins: {dvr: dvr(validatorjs)}, hooks}))

	useEffect(() => {
		RequestStore.getRequests()
		SettingsStore.getSettings()
	}, [])

	return (
		<Container maxWidth="lg">
			<Grid container justify="space-between" alignItems="center" className="pt-8">
				<Grid item xs>
					<Typography variant="h4">Zoznam žiadostí - back office</Typography>
				</Grid>
				<Grid container item xs={5} spacing={2} justify="flex-end">
					<Grid item>
						<XsButton
							text="EXPORT ÚDAJOV"
							icon={<i className="fas fa-arrow-to-bottom fa-lg"></i>}
							onClick={() => RequestStore.exportData(form)}
						/>
					</Grid>
					<Grid item>
						<XsButton
							text="EXPORT FULL"
							icon={<i className="fas fa-arrow-to-bottom fa-lg"></i>}
							onClick={() => RequestStore.exportDataFull()}
						/>
					</Grid>
				</Grid>
			</Grid>
			<Box pt={2}>
				<Grid container alignItems="center" style={{gap: 8}}>
					<Grid item>
						<Typography variant="caption" style={{fontWeight: "bold"}}>
							Vyhľadať v existujúcich záznamoch:
						</Typography>
					</Grid>
					<Grid item style={{flex: 1}}>
						<div style={{height: 1, backgroundColor: "#CED7D9", width: "100%"}}></div>
					</Grid>
				</Grid>
				<form onSubmit={form.onSubmit}>
					<Grid container alignItems="center" style={{gap: 8}} className="mt-3 mb-3">
						<Grid item xs={2}>
							<XsInput field={form.$("request_number")} />
						</Grid>
						<Grid item xs={2}>
							<XsInput field={form.$("search_name_ico")} />
						</Grid>
						<Grid item xs={2}>
							<XsSearchSelect field={form.$("request_state")} items={GlobalStore.CL["requestStatus"]} />
						</Grid>
						<Grid item xs={2}>
							<XsSearchSelect
								field={form.$("round")}
								items={
									SettingsStore.settingsData.length > 0
										? SettingsStore.settingsData.map((round) => ({
												...round,
												...{
													name_ext: `${round.region_type_code_ext} + ${round.device_group_name_ext} ${moment(
														round.start
													).format("DD.MM.YYYY")} - ${moment(round.validity_to).format("DD.MM.YYYY")}`,
													code: round.region_type_code_ext
												}
										  }))
										: []
								}
							/>
						</Grid>
						<Grid item>
							<XsIconButton
								rect
								className="xs-default xs-outline fa-pull-right"
								tooltip={"Aplikovať filtre"}
								type="submit"
								icon={
									<i
										className="far fa-search fa-lg xs-greyDefault"
										style={{paddingTop: "8px", paddingBottom: "8px", paddingLeft: "1px", paddingRight: "1px"}}
									></i>
								}
							/>
							<XsIconButton
								rect
								className="xs-default xs-outline fa-pull-right mr-1"
								tooltip={"Resetovať filtre"}
								variant="outlined"
								color="primary"
								onClick={(e) => {
									form.reset()
									form.onSubmit(e)
								}}
								icon={
									<i
										className="far fa-times fa-lg xs-greyDefault"
										style={{paddingTop: "9px", paddingBottom: "9px", paddingLeft: "4px", paddingRight: "4px"}}
									></i>
								}
							/>
						</Grid>
					</Grid>
				</form>
				<Grid container>
					<Grid item xs={12}>
						<Box pt={1}>
							<XsTable
								columns={columns}
								data={RequestStore.data}
								onRowClick={(row) => RouterStore.push(`/request?id=${row.request_id}`)}
							/>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Container>
	)
}

export default injectIntl(observer(Requests))

